/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTeamMemberAvailability} from '../api'

export const useMutationListTeamMemberAvailability = createReactQueryMutationHook('listTeamMemberAvailability', listTeamMemberAvailability)
